import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
  Divider,
  IconButton,
  Typography,
  Autocomplete,
  Tooltip,
} from "@mui/material";
import { notification } from "antd";
import { AllTypoFontStyles } from "../../../../Styles/styles";
import { FBIcon, TwitterIcon, WAIcon, EmailIcon } from "../../../../Svg/icons";
import { useDispatch, useSelector } from "react-redux";
import { setInviteLink } from "../../../../Redux/Slices/inviteLinkSlice";
import { InfoOutlined } from "@mui/icons-material";

const InviteTeamComponent = ({
  setSelectedTeams,
  selectedTeams,
  updatedLink,
  inviteLink,
}) => {
  const eventId = useSelector((state) => state.eventId.eventId);
  const eventInviteType = "team";
  const userDataString = localStorage.getItem("userData");
  const userData = JSON.parse(userDataString);
  const userId = userData?.id;
  const apiUrl = process.env.REACT_APP_API_URL;
  const [emails, setEmails] = useState([]);
  function encryptParam(param) {
    return btoa(param);
  }
  const encryptedEventId = encryptParam(eventId);
  const encryptedEventInviteType = encryptParam(eventInviteType);
  const encryptedUserId = encryptParam(userId);
  const dispatch = useDispatch();
  const newLink = `${apiUrl}/eventinvites?eventId=${encryptedEventId}&eventInviteType=${encryptedEventInviteType}&user=${encryptedUserId}`;
  useEffect(() => {
    dispatch(setInviteLink(newLink));
  }, [newLink]);

  const [loadingFetchContacts, setLoadingFetchContacts] = useState(false);
  const [token, setToken] = useState(null);
  const accessToken = JSON.parse(localStorage.getItem("accessToken"));

  const handleTeamSelectChange = (field, value, index) => {
    const updatedTeams = [...selectedTeams];
    updatedTeams[index] = {
      ...updatedTeams[index],
      [field]: value,
    };
    setSelectedTeams(updatedTeams);
  };

  const addMoreSelect = () => {
    const updatedTeams = [...selectedTeams, { email: "", name: "", lastName: "" }];
    setSelectedTeams(updatedTeams);
  };

  const handleShareClick = (platform) => {
    const encodedLink = encodeURIComponent(newLink);
    let shareUrl = "";
    switch (platform) {
      case "whatsapp":
        shareUrl = `https://wa.me/?text=${encodedLink}`;
        break;
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedLink}`;
        break;
      case "twitter":
        shareUrl = `https://twitter.com/intent/tweet?url=${encodedLink}`;
        break;
      case "email":
        shareUrl = `mailto:?subject=You're Invited!&body=${encodedLink}`;
        break;
      case "instagram":
        alert(
          "Instagram does not support direct link sharing. Please copy the link manually."
        );
        return;
      default:
        break;
    }
    if (shareUrl) {
      window.open(shareUrl, "_blank");
    }
  };

  const fetchContacts = async () => {
    setLoadingFetchContacts(true);
    try {
      if (!accessToken || emails.length === 0) {
        window.google.accounts.oauth2
          .initTokenClient({
            client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
            scope: "https://www.googleapis.com/auth/contacts.readonly",
            prompt: "consent",
            include_granted_scopes: true,
            state: 'pass-through-value',
            callback: async (response) => {
              if (response.access_token) {
                localStorage.setItem(
                  "accessToken",
                  JSON.stringify(response.access_token)
                );
                setToken(response.access_token);

                const contactResponse = await fetch(
                  `https://people.googleapis.com/v1/people/me/connections?pageSize=1000&personFields=names,emailAddresses`,
                  {
                    headers: {
                      Authorization: `Bearer ${response.access_token}`,
                    },
                  }
                );

                if (!contactResponse.ok) {
                  throw new Error("Failed to fetch contacts");
                }

                const data = await contactResponse.json();
                const contactsWithEmails = data?.connections?.filter(
                  (contact) => contact.emailAddresses
                );
                const emailList = contactsWithEmails?.map((contact) => ({
                  email: contact.emailAddresses[0]?.value,
                  name: contact.names?.[0]?.displayName || "",
                }));

                if (emailList && emailList.length > 0) {
                  setEmails(emailList);
                  notification.success({
                    message: "Contacts fetched successfully!",
                  });
                } else {
                  setEmails([]);
                  notification.info({
                    message: "No contacts found in your network!",
                  });
                }
              } else {
                throw new Error("Error retrieving access token");
              }
            },
          })
          .requestAccessToken();
      }
    } catch (error) {
      console.error("Error fetching contacts:", error);
      notification.error({
        message: "Failed to fetch contacts!",
        description: error.message,
      });
    } finally {
      setLoadingFetchContacts(false);
    }
  };

  return (
    <Grid spacing={2} p={{ md: 10, xs: 2 }}>
      <Grid
        spacing={{ xs: 1, md: 4 }}
        container
        alignItems="start"
        sx={{ mb: "10%" }}
      >
        <Grid item md={7} sm={12} xs={12}>
          <Grid spacing={2} direction="column" sx={{ width: "100%" }}>
            <Typography sx={AllTypoFontStyles.CommonTypo2}>
              Select Team
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1, mt: 1 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                <button
                  className="gsi-material-button"
                  onClick={fetchContacts}
                  disabled={loadingFetchContacts}
                >
                  <div className="gsi-material-button-state"></div>
                  <div className="gsi-material-button-content-wrapper">
                    <div className="gsi-material-button-icon">
                      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" xmlnsXlink="http://www.w3.org/1999/xlink">
                        <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                        <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                        <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                        <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                        <path fill="none" d="M0 0h48v48H0z"></path>
                      </svg>
                    </div>
                    <span className="gsi-material-button-contents">
                      {loadingFetchContacts ? "Importing..." : "Import from Google"}
                    </span>
                  </div>
                </button>

                <Tooltip
                  title={
                    <Box sx={{ p: 1 }}>
                      <Typography sx={{ fontSize: '13px', fontWeight: 'bold', mb: 1, color: '#fff' }}>
                        📧 Google Contacts Import
                      </Typography>
                      <Typography sx={{ fontSize: '12px', mb: 0.5, color: '#fff' }}>
                        ✓ Read-only access to your contacts
                      </Typography>
                      <Typography sx={{ fontSize: '12px', mb: 0.5, color: '#fff' }}>
                        ✓ Only names and emails are accessed
                      </Typography>
                      <Typography sx={{ fontSize: '12px', color: '#fff' }}>
                        ✓ Temporary - not stored permanently
                      </Typography>
                    </Box>
                  }
                  placement="bottom-start"
                  arrow
                  enterDelay={300}
                  leaveDelay={200} 
                  enterTouchDelay={0} 
                  leaveTouchDelay={500} 

                  sx={{
                    '& .MuiTooltip-tooltip': {
                      backgroundColor: '#1976d2',
                      color: '#fff',
                      fontSize: '12px',
                      borderRadius: '8px',
                      padding: '8px 12px',
                      maxWidth: '280px',
                    },
                    '& .MuiTooltip-arrow': {
                      color: '#1976d2',
                    }
                  }}
                >
                  <IconButton
                    size="small"
                    sx={{
                      color: "#1976d2",
                      padding: "4px",
                      marginLeft: "4px",
                      "&:hover": {
                        backgroundColor: "rgba(25, 118, 210, 0.08)",
                        color: "#1565c0"
                      },
                      "&:focus": {
                        backgroundColor: "rgba(25, 118, 210, 0.12)"
                      }
                    }}
                  >
                    <InfoOutlined fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>

            </Box>



            {/* Show contact count if available */}
            {emails.length > 0 && (
              <Typography sx={{ fontSize: '12px', color: '#4CAF50', mb: 1 }}>
                {emails.length} contacts imported successfully
              </Typography>
            )}
            {selectedTeams.map((team, index) => (
              <Grid
                key={index}
                container
                spacing={1}
                alignItems="center"
                mb={1}
              >
                <Grid item xs={5}>
                  <Autocomplete
                    freeSolo
                    options={emails || []}
                    getOptionLabel={(option) => option.email || ""}
                    onChange={(event, newValue) => {
                      if (typeof newValue === "string") {
                        handleTeamSelectChange("email", newValue, index);
                      } else if (newValue && typeof newValue === "object") {
                        handleTeamSelectChange("email", newValue.email, index);
                      } else {
                        handleTeamSelectChange("email", "", index);
                        handleTeamSelectChange("name", "", index);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Email"
                        fullWidth
                        onChange={(e) =>
                          handleTeamSelectChange("email", e.target.value, index)
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    placeholder="First Name"
                    fullWidth
                    value={team.name}
                    onChange={(e) =>
                      handleTeamSelectChange("name", e.target.value, index)
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    placeholder="Last Name"
                    fullWidth
                    value={team.lastName}
                    onChange={(e) =>
                      handleTeamSelectChange("lastName", e.target.value, index)
                    }
                  />
                </Grid>
                <Grid item xs={1}>
                  <IconButton
                    onClick={() => {
                      const updated = selectedTeams.filter(
                        (_, i) => i !== index
                      );
                      setSelectedTeams(updated);
                    }}
                  >
                    ❌
                  </IconButton>
                </Grid>
              </Grid>
            ))}

            <Grid item>
              <Button sx={{ color: "#003366" }} onClick={addMoreSelect}>
                + Add More
              </Button>
            </Grid>
          </Grid>
        </Grid>

        <Grid item md={1} sm={12} xs={12}>
          <Grid>
            <Grid item md={1} sm={12} xs={12}>
              <Divider
                orientation="vertical"
                sx={{
                  height: "200px",
                  color: "black",
                  display: { sm: "none", xs: "none", md: "block" },
                }}
              />
            </Grid>
            <Grid item md={1} sm={12} xs={12}>
              <Divider
                orientation="horizontal"
                sx={{
                  width: "100%",
                  color: "black",
                  display: { sm: "block", md: "none" },
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item md={4} sm={12} xs={12} mt={{ xs: 1, md: 0 }}>
          <Typography sx={AllTypoFontStyles.CommonTypo2}>Share</Typography>
          <Box textAlign="center">
            <Grid
              container
              spacing={2}
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "flex-start",
              }}
            >
              <Grid item xs={6} sm={4} md={6} lg={3}>
                <Box display="flex" flexDirection="column" alignItems="center">
                  <IconButton
                    color="primary"
                    onClick={() => handleShareClick("whatsapp")}
                  >
                    <WAIcon />
                  </IconButton>
                  <Typography sx={AllTypoFontStyles.CommonTypo3}>
                    Whatsapp
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={6} sm={4} md={6} lg={3}>
                <Box display="flex" flexDirection="column" alignItems="center">
                  <IconButton
                    color="primary"
                    onClick={() => handleShareClick("facebook")}
                  >
                    <FBIcon />
                  </IconButton>
                  <Typography sx={AllTypoFontStyles.CommonTypo3}>
                    Facebook
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={6} sm={4} md={6} lg={3}>
                <Box display="flex" flexDirection="column" alignItems="center">
                  <IconButton
                    color="primary"
                    onClick={() => handleShareClick("twitter")}
                  >
                    <TwitterIcon />
                  </IconButton>
                  <Typography sx={AllTypoFontStyles.CommonTypo3}>
                    Twitter
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={6} sm={4} md={6} lg={3}>
                <Box display="flex" flexDirection="column" alignItems="center">
                  <IconButton
                    color="primary"
                    onClick={() => handleShareClick("email")}
                  >
                    <EmailIcon />
                  </IconButton>
                  <Typography sx={AllTypoFontStyles.CommonTypo3}>
                    Email
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            <Box mt={3} sx={{ textAlign: "right" }}>
              <TextField
                value={newLink}
                fullWidth
                InputProps={{
                  readOnly: true,
                }}
              />
              <Button
                sx={{
                  marginTop: 1,
                  borderRadius: 1,
                  backgroundColor: "#2EA7E0",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#2EA7E0",
                  },
                }}
                onClick={() => {
                  if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard
                      .writeText(newLink)
                      .then(() => {
                        notification.success({
                          message: "Link copied successfully!",
                        });
                      })
                      .catch((err) => {
                        console.error("Failed to copy:", err);
                      });
                  } else {
                    const textArea = document.createElement("textarea");
                    textArea.value = newLink;
                    document.body.appendChild(textArea);
                    textArea.select();
                    try {
                      document.execCommand("copy");
                      notification.success({
                        message: "Link copied successfully!",
                      });
                    } catch (err) {
                      console.error("Fallback: Unable to copy", err);
                    }
                    document.body.removeChild(textArea);
                  }
                }}
              >
                Copy
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default InviteTeamComponent;
